import React, { useState, useEffect } from 'react'
import { Typography, Button } from '../../../components'
import { Formik } from 'formik'
import * as Yup from 'yup'
import Input from '../../../components/Form/Input'
import { Form, FormBody, FormFooter } from '../../../components/Form/styles'
import { DefaultRegularPages } from '../../DefaultPages'
import useQueryParams from '../../../hooks/useQueryParams'

import { Container, SubContainer, Title } from './styles'
import ErrorMessage from '../../../components/Form/ErrorMessage'
import ecbrApi from '../../../services/ecbrApi'
import useHistory from '../../../hooks/useHistory'
import useScrollToTop from '../../../hooks/useScrollToTop'
import { extractErrorMessage } from '../../../helpers/extractErrorMessage'

const initialValues = {
  password: '',
  confirmPassword: ''
}

const formSchema = Yup.object().shape({
  password: Yup.string().required('Campo obrigatório'),
  confirmPassword: Yup.string()
    .required('Confirme sua senha')
    .oneOf([Yup.ref('password'), ''], 'Confirmação de senha incorreta')
})

const PasswordRedefinition = () => {
  const [error, setError] = useState('')
  const [redefinitionFinished, setRedefinitionFinished] = useState(false)
  const hash = useQueryParams().get('hash')
  const history = useHistory()
  const { scrollToTop } = useScrollToTop()

  const onSubmit = async ({ password }, { setSubmitting }) => {
    const defaultErrorMessage =
      'Ocorreu um erro ao redefinir sua senha. Tente novamente.'
    try {
      setSubmitting(true)
      const response = await ecbrApi.auth.resetPassword(hash, password)
      // response.data example:
      // {
      //   "status": "success"
      // }

      if (response.data.status === 'success') {
        setRedefinitionFinished(true)
      } else {
        setError(defaultErrorMessage)
      }
      setSubmitting(false)
    } catch (err) {
      console.log({ err })
      const errorMessage = extractErrorMessage(err, defaultErrorMessage)
      setError(errorMessage)
      setSubmitting(false)
    }
  }

  useEffect(() => {
    if (redefinitionFinished) {
      scrollToTop()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redefinitionFinished])

  const handleLogin = () => {
    history.push('/login')
  }

  if (!hash) {
    return (
      <DefaultRegularPages>
        <Container>
          <SubContainer>
            <Title>
              <Typography type="h4" spacing="auto">
                Você não tem permissão para acessar essa página
              </Typography>
            </Title>
          </SubContainer>
        </Container>
      </DefaultRegularPages>
    )
  }

  return (
    <DefaultRegularPages>
      <Container>
        <SubContainer>
          <Title>Redefinição de Senha</Title>
          {redefinitionFinished ? (
            <>
              <Typography
                type="text"
                color="#7D7987"
                spacing="1rem 0 1.5rem 0"
                align="center"
              >
                Senha redefinida com sucesso!
              </Typography>
              <Typography
                type="text"
                color="#7D7987"
                spacing="0 0 1.5rem 0"
                align="center"
              >
                Agora você pode fazer login usando a sua nova senha.
              </Typography>
              <Button
                text="FAZER LOGIN"
                onClick={handleLogin}
                type="button"
                variant="primary"
                width="200px"
              />
            </>
          ) : (
            <>
              <Typography
                type="text"
                color="#7D7987"
                spacing="1rem 0 1.5rem 0"
                align="center"
              >
                Crie uma nova senha para o seu usuário.
              </Typography>
              <Formik
                initialValues={initialValues}
                validationSchema={formSchema}
                onSubmit={onSubmit}
              >
                {({ isSubmitting }) => (
                  <Form maxWidth="100%">
                    <FormBody>
                      <Input name="password" type="password" label="Senha" />
                      <Input
                        name="confirmPassword"
                        type="password"
                        label="Confirmar senha"
                      />
                      <ErrorMessage>{error}</ErrorMessage>
                    </FormBody>
                    <FormFooter>
                      <Button
                        text="REDEFINIR SENHA"
                        type="submit"
                        variant="primary"
                        width="200px"
                        disabled={isSubmitting}
                      />
                    </FormFooter>
                  </Form>
                )}
              </Formik>
            </>
          )}
        </SubContainer>
      </Container>
    </DefaultRegularPages>
  )
}

export default PasswordRedefinition
